module.exports = __webpack_public_path__ + "static/media/house-mobile.55d39d61.svg";